import { render, staticRenderFns } from "./CreateNewPage.vue?vue&type=template&id=0fe89078&"
import script from "./CreateNewPage.vue?vue&type=script&lang=js&"
export * from "./CreateNewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports